import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const setPropertyWalkThroughFormData = (state, { payload }) => {
  return {
    ...state,
    data: {
      ...state.data,
      ...payload
    },
  };
};

const setPropertyWalkThroughFormNextStep = (state, { payload }) => {
  return {
    ...state,
    step: state.step + 1,
    // step:  1,
  };
};

const setPropertyWalkThroughFormPreviousStep = (state, { payload }) => {
  return {
    ...state,
    step: state.step - 1,
  };
};

const setPropertyWalkThroughFormStep = (state, { payload }) => {
  return {
    ...state,
    step: payload.step,
  };
};

const exitPropertyWalkThroughForm = (state) => {
  return {
    isVisible: false,
    step: 0,
    data: {},
  };
};

const setPropertyWalkThroughFormIsVisible = (state, { payload }) => {
  return {
    ...state,
    isVisible: payload,
  };
};

const initialState = {
  step: 0,
};

export default createReducer(initialState, {
  [TYPES.EXIT_PROPERTY_WALK_THROUGH_FORM]: exitPropertyWalkThroughForm,
  [TYPES.SET_PROPERTY_WALK_THROUGH_FORM_DATA]: setPropertyWalkThroughFormData,
  [TYPES.SET_PROPERTY_WALK_THROUGH_FORM_IS_VISIBLE]: setPropertyWalkThroughFormIsVisible,
  [TYPES.SET_PROPERTY_WALK_THROUGH_FORM_NEXT_STEP]: setPropertyWalkThroughFormNextStep,
  [TYPES.SET_PROPERTY_WALK_THROUGH_FORM_PREVIOUS_STEP]: setPropertyWalkThroughFormPreviousStep,
  [TYPES.SET_PROPERTY_WALK_THROUGH_FROM_STEP]: setPropertyWalkThroughFormStep
});
